<template>
  <div class="page">
    <SubHeader :page="page"></SubHeader>
    <CareersContent></CareersContent>
  </div>
</template>

<script>

const pageName = 'Careers'
import SubHeader from './common/SubHeader'
import CareersContent from './content/CareersContent'
export default {
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    SubHeader,
    CareersContent
  },
  methods: {},
  computed: {
    page() {
      return pageName
    }
  },
  watch: {}
}
</script>

<style scoped>
  .page {
    font-family: 'Work Sans', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// Careers.vue?7da3a69c